module.exports = __webpack_public_path__ + "4b7ba51a2c4b0ad93e0037a0dc0bf15f.png";